import React from 'react';
import { MainLayout } from './core/layouts/MainLayout';
import { PageRenderer } from './features/landing/components/PageRenderer';

export const Main = () => {
  return (
    <MainLayout>
      <PageRenderer slug="home" />
    </MainLayout>
  );
};
